export default "__VITE_ASSET__Bx8Wvw0K__"